<template>
  <div class="format-buttons">
    <button
      @click="editor.chain().focus().toggleBold().run()"
      :disabled="!editor.can().chain().focus().toggleBold().run()"
      :class="{ 'is-active': editor.isActive('bold') }"
      title="Bold"
    >
      <img src="/images/tiptap-bar/bold.svg" alt="Bold" />
    </button>
    <button
      @click="editor.chain().focus().toggleItalic().run()"
      :disabled="!editor.can().chain().focus().toggleItalic().run()"
      :class="{ 'is-active': editor.isActive('italic') }"
      title="Italic"
    >
      <img src="/images/tiptap-bar/italic.svg" alt="Italic" />
    </button>
    <button
      @click="editor.chain().focus().toggleUnderline().run()"
      :disabled="!editor.can().chain().focus().toggleUnderline().run()"
      :class="{ 'is-active': editor.isActive('underline') }"
      title="Underline"
    >
      <img src="/images/tiptap-bar/underline.svg" alt="Underline" />
    </button>
    <button
      @click="editor.chain().focus().toggleStrike().run()"
      :disabled="!editor.can().chain().focus().toggleStrike().run()"
      :class="{ 'is-active': editor.isActive('strike') }"
      title="Strikethrough"
    >
      <img src="/images/tiptap-bar/strike.svg" alt="Strikethrough" />
    </button>
    <button
      @click="editor.chain().focus().toggleHighlight().run()"
      :disabled="!editor.can().chain().focus().toggleHighlight().run()"
      :class="{ 'is-active': editor.isActive('highlight') }"
      title="Highlight"
    >
      <img src="/images/tiptap-bar/highlight.svg" alt="Highlight" />
    </button>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  editor: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped>
.format-buttons {
  display: flex;
  gap: 5px;
}
</style>
